import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "width"];
import defaultTheme, { border, color, colorStyle, radius, textStyle } from '@repay/cactus-theme';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { compose, margin, width } from 'styled-system';
import { omitMargins } from '../helpers/omit';
import { getStatusStyles, StatusPropType } from '../helpers/status';
export var textStyles = Object.keys(defaultTheme.textStyles);
var TextInputBase = /*#__PURE__*/React.forwardRef(function (props, forwardRef) {
  var _omitMargins = omitMargins(props),
      className = _omitMargins.className,
      widthProp = _omitMargins.width,
      rest = _objectWithoutProperties(_omitMargins, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Input, Object.assign({
    ref: forwardRef
  }, rest, {
    $width: widthProp ? '100%' : 'auto'
  })));
});
export var commonInputStyles = /*#__PURE__*/css(["box-sizing:border-box;border:", ";outline:none;", " &:disabled{cursor:not-allowed;border-color:", ";", "}&:disabled::placeholder{color:", ";}&:focus{border-color:", ";}&::placeholder{color:", ";font-style:italic;}", ""], border('darkContrast'), colorStyle('standard'), color('lightGray'), colorStyle('disable'), color('mediumGray'), color('callToAction'), color('mediumContrast'), getStatusStyles);
var Input = /*#__PURE__*/styled.input.withConfig({
  displayName: "Input"
})(["border-radius:", ";padding:3px 28px 3px 15px;", ";width:", ";", ""], radius(20), function (p) {
  return textStyle(p, p.textStyle || 'body');
}, function (p) {
  return p.$width;
}, commonInputStyles);
export var TextInput = /*#__PURE__*/styled(TextInputBase).withConfig({
  displayName: "TextInput"
})(["box-sizing:border-box;&&&{", "}"], compose(margin, width));
TextInput.propTypes = {
  disabled: PropTypes.bool,
  status: StatusPropType,
  textStyle: PropTypes.oneOf(textStyles)
};
export default TextInput;